import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "./style.css";
import Form from './Form.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
// import Counter from '../../../NumCounter.js'
import Counter from '../../../NumCounter.js'
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Mouth Ulcers Treatment in Delhi, India | Causes, Cost, Doctor, Clinic</title>
            <meta name="description" content="Get effective mouth ulcer treatment in Delhi, India. Learn about causes, remedies, and treatment cost at MedFirst ENT Centre." />
            <meta name="keywords" content="Best mouth ulcer Doctor in Delhi,Best mouth ulcer doctor near me,Mouth Specialist Doctor in Delhi,Mouth ulcer doctor specialist,Mouth ulcer doctor near me,Best Hospital for Mouth ulcer treatment,Mouth specialist near me,Mouth Specialist doctor near me" />
            <link rel="canonical" href="https://entdelhi.com/mouth-ulcers/" />
            <meta property="og:title" content="Mouth Ulcers Treatment in Delhi, India | Causes, Cost, Doctor, Clinic" />
            <meta property="og:description" content="Get effective mouth ulcer treatment in Delhi, India. Learn about causes, remedies, and treatment cost at MedFirst ENT Centre." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
      <main>
        <Breadcrumb/>
        <Form />  
         <Counter/>
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
